// RequiredAuth.js
import React from "react";
import { useOktaAuth } from "@okta/okta-react";
import { toRelativeUrl } from "@okta/okta-auth-js";
import { Outlet, useLocation } from "react-router-dom";
import LoadingOkta from "./LoadingOkta";

export const RequiredAuth = () => {
  const { oktaAuth, authState } = useOktaAuth();
  const location = useLocation();

  // Show a loading indicator while the auth state is being resolved
  if (!authState) {
    return <LoadingOkta />;
  }

  // Redirect to the login page if the user is not authenticated
  if (!authState.isAuthenticated) {
    const originalUri = toRelativeUrl(location.pathname, window.location.origin);
    oktaAuth.setOriginalUri(originalUri);
    oktaAuth.signInWithRedirect();
    return <LoadingOkta />; // Show the loading component while redirecting
  }

  // Render the Outlet component to display protected routes if the user is authenticated
  return <Outlet />;
};

